export const GATEWAY_MODE_ONSITE = 'ON_SITE'
export const GATEWAY_MODE_VIRTUAL = 'VIRTUAL'
